var u = (p, s, t) => new Promise((l, a) => {
  var i = (e) => {
    try {
      n(t.next(e));
    } catch (o) {
      a(o);
    }
  }, m = (e) => {
    try {
      n(t.throw(e));
    } catch (o) {
      a(o);
    }
  }, n = (e) => e.done ? l(e.value) : Promise.resolve(e.value).then(i, m);
  n((t = t.apply(p, s)).next());
});
import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import y from "./aiCancelDialog.ce.vue.js";
import N from "./notAiCancelDialog.ce.vue.js";
import { vCopyVueucStylesToShadowDom as h } from "../../utils/vCopyVueucStylesToShadowDom.js";
import { defineComponent as D, useTemplateRef as C, withDirectives as R, openBlock as A, createBlock as w, withCtx as _, createVNode as d } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useShadowRoot as S } from "../../node_modules/.pnpm/@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
import { unref as r } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import x from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/common/zhCN.js";
import O from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/date/zhCN.js";
import P from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/config-provider/src/ConfigProvider.js";
import k from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/MessageProvider.js";
const j = /* @__PURE__ */ D({
  __name: "index.ce",
  setup(p, { expose: s }) {
    const t = C("aiCancelDialogRefs"), l = C("notAiCancelDialogRefs");
    let a = null;
    const i = S(), m = {
      common: {
        primaryColor: "#FC9153",
        primaryColorHover: "#FC9153",
        primaryColorPressed: "#FC9153",
        primaryColorSuppl: "#FC9153"
      }
    }, n = (o) => u(this, null, function* () {
      var c, f;
      return o.notAi || (c = t.value) == null || c.open({
        orderId: o.orderId || "",
        productionOrderContractNo: o.productionOrderContractNo || "",
        status: o.status || "",
        statusName: o.statusName || ""
      }), console.log(o.notAi, "v.notAi"), o.notAi && ((f = l.value) == null || f.open({
        orderId: o.orderId || "",
        productionOrderContractNo: o.productionOrderContractNo || ""
      })), new Promise((g) => {
        a = g;
      });
    }), e = (o) => {
      a && (a(o), a = null);
    };
    return s({ open: n }), (o, c) => R((A(), w(r(P), {
      locale: r(x),
      "date-locale": r(O),
      "theme-overrides": m,
      "style-mount-target": r(i)
    }, {
      default: _(() => [
        d(r(k), { to: r(i) }, {
          default: _(() => [
            d(y, {
              ref_key: "aiCancelDialogRefs",
              ref: t,
              onSubmit: e
            }, null, 512),
            d(N, {
              ref_key: "notAiCancelDialogRefs",
              ref: l,
              onSubmit: e
            }, null, 512)
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    }, 8, ["locale", "date-locale", "style-mount-target"])), [
      [r(h), r(i)]
    ]);
  }
});
export {
  j as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/ai-cancel-dialog/index.ce.vue2.js
// module id = 1193
// module chunks = 67